export const START_CALL = "CALL::START_CALL";
export const START_CALL_SUCCEEDED = "CALL::START_CALL_SUCCEEDED";
export const START_CALL_FAILED = "CALL::START_CALL_FAILED";

export const END_CALL = "CALL::END_CALL";
export const END_CALL_SUCCEEDED = "CALL::END_CALL_SUCCEEDED";
export const END_CALL_FAILED = "CALL::END_CALL_FAILED";

export const REJOIN_CALL = "CALL::REJOIN_CALL";

export const PARTICIPANTS_CHANGES_SUBSCRIBE =
  "CALL::PARTICIPANTS_CHANGES_SUBSCRIBE";
export const PARTICIPANTS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::PARTICIPANTS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const PARTICIPANTS_CHANGES_SUBSCRIBE_FAILED =
  "CALL::PARTICIPANTS_CHANGES_SUBSCRIBE_FAILED";

export const RESOURCE_MANAGER_CHANGES_SUBSCRIBE =
  "CALL::RESOURCE_MANAGER_CHANGES_SUBSCRIBE";
export const RESOURCE_MANAGER_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::RESOURCE_MANAGER_CHANGES_SUBSCRIBE_SUCCEEDED";
export const RESOURCE_MANAGER_CHANGES_SUBSCRIBE_FAILED =
  "CALL::RESOURCE_MANAGER_CHANGES_SUBSCRIBE_FAILED";

export const RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE =
  "CALL::RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE";
export const RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::RESOURCE_MANAGER_CHANGES_UNSUBSCRIBE_FAILED";

export const RECORDER_STATUS_CHANGES_SUBSCRIBE =
  "CALL::RECORDER_STATUS_CHANGES_SUBSCRIBE";
export const RECORDER_STATUS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::RECORDER_STATUS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const RECORDER_STATUS_CHANGES_SUBSCRIBE_FAILED =
  "CALL::RECORDER_STATUS_CHANGES_SUBSCRIBE_FAILED";

export const RECORDER_STATUS_CHANGES_UNSUBSCRIBE =
  "CALL::RECORDER_STATUS_CHANGES_UNSUBSCRIBE";
export const RECORDER_STATUS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::RECORDER_STATUS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const RECORDER_STATUS_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::RECORDER_STATUS_CHANGES_UNSUBSCRIBE_FAILED";

export const PARTICIPANTS_CHANGES_UNSUBSCRIBE =
  "CALL::PARTICIPANTS_CHANGES_UNSUBSCRIBE";
export const PARTICIPANTS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::PARTICIPANTS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const PARTICIPANTS_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::PARTICIPANTS_CHANGES_UNSUBSCRIBE_FAILED";

export const UPDATE_PARTICIPANTS = "CALL::UPDATE_PARTICIPANTS";
export const UPDATE_RECORDER_STATUS = "CALL::UPDATE_RECORDER_STATUS";
export const UPDATE_AVAILIBLE_RESOURCES = "CALL::UPDATE_AVAILIBLE_RESOURCES";

export const ASSIGN_VIDEO_RENDERER = "CALL::ASSIGN_VIDEO_RENDERER";
export const ASSIGN_VIDEO_RENDERER_SUCCEEDED =
  "CALL::ASSIGN_VIDEO_RENDERER_SUCCEEDED";
export const ASSIGN_VIDEO_RENDERER_FAILED =
  "CALL::ASSIGN_VIDEO_RENDERER_FAILED";

export const LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE";
export const LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE_SUCCEEDED";
export const LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE_FAILED =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_SUBSCRIBE_FAILED";

export const LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE";
export const LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::LOCAL_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_FAILED";

export const REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE";
export const REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE_SUCCEEDED";
export const REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE_FAILED =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_SUBSCRIBE_FAILED";

export const REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE";
export const REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::REMOTE_WINDOW_SHARE_CHANGES_UNSUBSCRIBE_FAILED";

export const LOCAL_WINDOW_SHARES_UPDATE = "CALL::LOCAL_WINDOW_SHARES_UPDATE";
export const REMOTE_WINDOW_SHARES_UPDATE = "CALL::REMOTE_WINDOW_SHARES_UPDATE";

export const WINDOW_SHARE_START = "CALL::WINDOW_SHARE_START";
export const WINDOW_SHARE_START_SUCCEEDED =
  "CALL::WINDOW_SHARE_START_SUCCEEDED";
export const WINDOW_SHARE_START_FAILED = "CALL::WINDOW_SHARE_START_FAILED";

export const WINDOW_SHARE_STOP = "CALL::WINDOW_SHARE_STOP";
export const WINDOW_SHARE_STOP_SUCCEEDED = "CALL::WINDOW_SHARE_STOP_SUCCEEDED";
export const WINDOW_SHARE_STOP_FAILED = "CALL::WINDOW_SHARE_STOP_FAILED";

export const GET_CALL_PROPERTIES = "CALL::GET_PROPERTIES";
export const GET_CALL_PROPERTIES_SUCCEEDED = "CALL::GET_PROPERTIES_SUCCEEDED";
export const GET_CALL_PROPERTIES_FAILED = "CALL::GET_PROPERTIES_FAILED";

export const PIN_PARTICIPANT = "CALL::PIN_PARTICIPANT";
export const PIN_PARTICIPANT_SUCCEEDED = "CALL::PIN_PARTICIPANT_SUCCEEDED";
export const PIN_PARTICIPANT_FAILED = "CALL::PIN_PARTICIPANT_FAILED";

export const UNPIN_PARTICIPANT = "CALL::UNPIN_PARTICIPANT";
export const UNPIN_PARTICIPANT_SUCCEEDED = "CALL::UNPIN_PARTICIPANT_SUCCEEDED";
export const UNPIN_PARTICIPANT_FAILED = "CALL::UNPIN_PARTICIPANT_FAILED";

export const OPEN_MODERATION_PANEL = "CALL::OPEN_MODERATION_PANEL";
export const CLOSE_MODERATION_PANEL = "CALL::CLOSE_MODERATION_PANEL";

export const SET_ROOM_INFO = "CALL::SET_ROOM_INFO";
export const RESET_ROOM_INFO = "CALL::RESET_ROOM_INFO";

export const LOCK_ROOM = "CALL::LOCK_ROOM";
export const UNLOCK_ROOM = "CALL::UNLOCK_ROOM";

export const SAVE_ROOM_PIN = "CALL::SAVE_ROOM_PIN";

export const SAVE_PARTICIPANTS_DETAILS = "CALL::SAVE_PARTICIPANTS_DETAILS";

export const SHOW_PREVIEW = "CALL::SHOW_PREVIEW";
export const SHOW_PREVIEW_SUCCEEDED = "CALL::SHOW_PREVIEW_SUCCEEDED";
export const SHOW_PREVIEW_FAILED = "CALL::SHOW_PREVIEW_FAILED";

export const SHOW_SHARE_PREVIEW = "CALL::SHOW_SHARE_PREVIEW";
export const SHOW_SHARE_PREVIEW_SUCCEEDED =
  "CALL::SHOW_SHARE_PREVIEW_SUCCEEDED";
export const SHOW_SHARE_PREVIEW_FAILED = "CALL::SHOW_SHARE_PREVIEW_FAILED";

export const MODERATION_EVENTS_SUBSCRIBE = "CALL::MODERATION_EVENTS_SUBSCRIBE";
export const MODERATION_EVENTS_SUBSCRIBE_SUCCEEDED =
  "CALL::MODERATION_EVENTS_SUBSCRIBE_SUCCEEDED";
export const MODERATION_EVENTS_SUBSCRIBE_FAILED =
  "CALL::MODERATION_EVENTS_SUBSCRIBE_FAILED";
export const MODERATION_EVENTS_UNSUBSCRIBE =
  "CALL::MODERATION_EVENTS_UNSUBSCRIBE";
export const MODERATION_EVENTS_UNSUBSCRIBE_SUCCEEDED =
  "CALL::MODERATION_EVENTS_UNSUBSCRIBE_SUCCEEDED";
export const MODERATION_EVENTS_UNSUBSCRIBE_FAILED =
  "CALL::MODERATION_EVENTS_UNSUBSCRIBE_FAILED";

export const COMPOSITOR_UPDATES_SUBSCRIBE =
  "CALL::COMPOSITOR_UPDATES_SUBSCRIBE";
export const COMPOSITOR_UPDATES_SUBSCRIBE_SUCCEEDED =
  "CALL::COMPOSITOR_UPDATES_SUBSCRIBE_SUCCEEDED";
export const COMPOSITOR_UPDATES_SUBSCRIBE_FAILED =
  "CALL::COMPOSITOR_UPDATES_SUBSCRIBE_FAILED";

export const COMPOSITOR_UPDATES_UNSUBSCRIBE =
  "CALL::COMPOSITOR_UPDATES_UNSUBSCRIBE";
export const COMPOSITOR_UPDATES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::COMPOSITOR_UPDATES_UNSUBSCRIBE_SUCCEEDED";
export const COMPOSITOR_UPDATES_UNSUBSCRIBE_FAILED =
  "CALL::COMPOSITOR_UPDATES_UNSUBSCRIBE_FAILED";

export const COMPOSITOR_SET_GRID_VIEW = "CALL::COMPOSITOR_SET_GRID_VIEW";
export const COMPOSITOR_SET_GRID_VIEW_SUCCEEDED =
  "CALL::COMPOSITOR_SET_GRID_VIEW_SUCCEEDED";
export const COMPOSITOR_SET_GRID_VIEW_FAILED =
  "CALL::COMPOSITOR_SET_GRID_VIEW_FAILED";

export const COMPOSITOR_SET_GALLERY_VIEW = "CALL::COMPOSITOR_SET_GALLERY_VIEW";
export const COMPOSITOR_SET_GALLERY_VIEW_SUCCEEDED =
  "CALL::COMPOSITOR_SET_GALLERY_VIEW_SUCCEEDED";
export const COMPOSITOR_SET_GALLERY_VIEW_FAILED =
  "CALL::COMPOSITOR_SET_GALLERY_VIEW_FAILED";

export const COMPOSITOR_UPDATED = "CALL::COMPOSITOR_UPDATED";
export const COMPOSITOR_VIEW_TYPE_CHANGED =
  "CALL::COMPOSITOR_VIEW_TYPE_CHANGED";

export const COMPOSITOR_VIEW_CHANGES_SUBSCRIBE =
  "CALL::COMPOSITOR_VIEW_CHANGES_SUBSCRIBE";
export const COMPOSITOR_VIEW_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::COMPOSITOR_VIEW_CHANGES_SUBSCRIBE_SUCCEEDED";
export const COMPOSITOR_VIEW_CHANGES_SUBSCRIBE_FAILED =
  "CALL::COMPOSITOR_VIEW_CHANGES_SUBSCRIBE_FAILED";

export const COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE =
  "CALL::COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE";
export const COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::COMPOSITOR_VIEW_CHANGES_UNSUBSCRIBE_FAILED";

export const FECC_PRESETS_SET_TITLE = "CALL::FECC_PRESETS_SET_TITLE";
export const FECC_PRESETS_SET_TITLE_SUCCEEDED =
  "CALL::FECC_PRESETS_SET_TITLE_SUCCEEDED";
export const FECC_PRESETS_SET_TITLE_FAILED =
  "CALL::FECC_PRESETS_SET_TITLE_FAILED";

export const FECC_PRESETS_SELECT_SET_TITLE =
  "CALL::FECC_PRESETS_SELECT_SET_TITLE";
export const FECC_PRESETS_SELECT_SET_TITLE_SUCCEEDED =
  "CALL::FECC_PRESETS_SELECT_SET_TITLE_SUCCEEDED";
export const FECC_PRESETS_SELECT_SET_TITLE_FAILED =
  "CALL::FECC_PRESETS_SET_TITLE_FAILED";

export const CAMERA_PRESETS_CHANGES_SUBSCRIBE =
  "CALL::CAMERA_PRESETS_CHANGES_SUBSCRIBE";
export const CAMERA_PRESETS_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::CAMERA_PRESETS_CHANGES_SUBSCRIBE_SUCCEEDED";
export const CAMERA_PRESETS_CHANGES_SUBSCRIBE_FAILED =
  "CALL::CAMERA_PRESETS_CHANGES_SUBSCRIBE_FAILED";

export const CAMERA_PRESETS_CHANGES_UNSUBSCRIBE =
  "CALL::CAMERA_PRESETS_CHANGES_UNSUBSCRIBE";
export const CAMERA_PRESETS_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::CAMERA_PRESETS_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const CAMERA_PRESETS_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::CAMERA_PRESETS_CHANGES_UNSUBSCRIBE_FAILED";

export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE";
export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE_SUCCEEDED =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE_SUCCEEDED";
export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE_FAILED =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_SUBSCRIBE_FAILED";

export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE";
export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE_SUCCEEDED";
export const CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE_FAILED =
  "CALL::CAMERA_CONTROLS_PANEL_STATE_CHANGES_UNSUBSCRIBE_FAILED";

export const FECC_STATE_TOGGLE = "CALL::FECC_STATE_TOGGLE";

export const CC_BTN_SET_STATE = "CALL::CC_BTN_SET_STATE";
export const CC_SET_INIT_FLAG = "CALL::CC_SET_INIT_FLAG";
export const CC_SET_ANALYTICS = "CALL::CC_SET_ANALYTICS";
export const CC_SET_IN_PROGRESS = "CALL::CC_SET_IN_PROGRESS";
export const CC_STOP_SUCCEEDED = "CALL::CC_STOP_SUCCEEDED";

export const SUBSCRIBE_TO_TOPIC = "CALL::SUBSCRIBE_TO_TOPIC";
export const SUBSCRIBE_TO_TOPIC_SUCCEEDED =
  "CALL::SUBSCRIBE_TO_TOPIC_SUCCEEDED";
export const SUBSCRIBE_TO_TOPIC_FAILED = "CALL::SUBSCRIBE_TO_TOPIC_FAILED";

export const UNSUBSCRIBE_FROM_TOPIC = "CALL::UNSUBSCRIBE_FROM_TOPIC";
export const UNSUBSCRIBE_FROM_TOPIC_SUCCEEDED =
  "CALL::UNSUBSCRIBE_FROM_TOPIC_SUCCEEDED";
export const UNSUBSCRIBE_FROM_TOPIC_FAILED =
  "CALL::UNSUBSCRIBE_FROM_TOPIC_FAILED";

export const MODERATION_TOPIC_SUBSCRIBE = "CALL::MODERATION_TOPIC_SUBSCRIBE";
export const MODERATION_TOPIC_SUBSCRIBE_SUCCEEDED =
  "CALL::MODERATION_TOPIC_SUBSCRIBE_SUCCEEDED";
export const MODERATION_TOPIC_SUBSCRIBE_FAILED =
  "CALL::MODERATION_TOPIC_SUBSCRIBE_FAILED";
export const MODERATION_TOPIC_UNSUBSCRIBE =
  "CALL::MODERATION_TOPIC_UNSUBSCRIBE";
export const MODERATION_TOPIC_UNSUBSCRIBE_SUCCEEDED =
  "CALL::MODERATION_TOPIC_UNSUBSCRIBE_SUCCEEDED";
export const MODERATION_TOPIC_UNSUBSCRIBE_FAILED =
  "CALL::MODERATION_TOPIC_UNSUBSCRIBE_FAILED";

export const SET_DISCONNECT_REASON = "CALL::SET_DISCONNECT_REASON";

export const SET_EXTDATA_INVITEES = "CALL::SET_EXTDATA_INVITEES";
export const MARK_EXTDATA_INVITEE = "CALL::MARK_EXTDATA_INVITEE";
export const SET_REDIAL_REQIRED = "CALL::SET_REDIAL_REQIRED";
export const SET_CALL_END_TIME = "CALL::SET_CALL_END_TIME";

export const CLOSED_CAPTION_OPENED = "CALL::CLOSED_CAPTION_OPENED";
export const CLOSED_CAPTION_CLOSED = "CALL::CLOSED_CAPTION_CLOSED";

export const BOT_MESSAGES_SUBSCRIBE_SUCCEEDED =
  "CALL::BOT_MESSAGES_SUBSCRIBE_SUCCEEDED";
export const BOT_MESSAGES_SUBSCRIBE_FAILED =
  "CALL::BOT_MESSAGES_SUBSCRIBE_FAILED";

export const BOT_MESSAGES_UNSUBSCRIBE_SUCCEEDED =
  "CALL::BOT_MESSAGES_UNSUBSCRIBE_SUCCEEDED";
export const BOT_MESSAGES_UNSUBSCRIBE_FAILED =
  "CALL::BOT_MESSAGES_UNSUBSCRIBE_FAILED";

export const CLOSED_CC_NOTIFICATION = "CALL::CLOSED_CC_NOTIFICATION";

export const OPENED_CC_NOTIFICATION = "CALL::OPENED_CC_NOTIFICATION";
